import { SVGProps } from "react";

const DashboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5477_33928)">
      <path
        d="M4.16634 3.33203H7.49967C7.72069 3.33203 7.93265 3.41983 8.08893 3.57611C8.24521 3.73239 8.33301 3.94435 8.33301 4.16536V9.16536C8.33301 9.38638 8.24521 9.59834 8.08893 9.75462C7.93265 9.9109 7.72069 9.9987 7.49967 9.9987H4.16634C3.94533 9.9987 3.73337 9.9109 3.57709 9.75462C3.42081 9.59834 3.33301 9.38638 3.33301 9.16536V4.16536C3.33301 3.94435 3.42081 3.73239 3.57709 3.57611C3.73337 3.41983 3.94533 3.33203 4.16634 3.33203Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16634 13.332H7.49967C7.72069 13.332 7.93265 13.4198 8.08893 13.5761C8.24521 13.7324 8.33301 13.9444 8.33301 14.1654V15.832C8.33301 16.053 8.24521 16.265 8.08893 16.4213C7.93265 16.5776 7.72069 16.6654 7.49967 16.6654H4.16634C3.94533 16.6654 3.73337 16.5776 3.57709 16.4213C3.42081 16.265 3.33301 16.053 3.33301 15.832V14.1654C3.33301 13.9444 3.42081 13.7324 3.57709 13.5761C3.73337 13.4198 3.94533 13.332 4.16634 13.332Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5003 10H15.8337C16.0547 10 16.2666 10.0878 16.4229 10.2441C16.5792 10.4004 16.667 10.6123 16.667 10.8333V15.8333C16.667 16.0543 16.5792 16.2663 16.4229 16.4226C16.2666 16.5789 16.0547 16.6667 15.8337 16.6667H12.5003C12.2793 16.6667 12.0674 16.5789 11.9111 16.4226C11.7548 16.2663 11.667 16.0543 11.667 15.8333V10.8333C11.667 10.6123 11.7548 10.4004 11.9111 10.2441C12.0674 10.0878 12.2793 10 12.5003 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5003 3.33203H15.8337C16.0547 3.33203 16.2666 3.41983 16.4229 3.57611C16.5792 3.73239 16.667 3.94435 16.667 4.16536V5.83203C16.667 6.05304 16.5792 6.26501 16.4229 6.42129C16.2666 6.57757 16.0547 6.66536 15.8337 6.66536H12.5003C12.2793 6.66536 12.0674 6.57757 11.9111 6.42129C11.7548 6.26501 11.667 6.05304 11.667 5.83203V4.16536C11.667 3.94435 11.7548 3.73239 11.9111 3.57611C12.0674 3.41983 12.2793 3.33203 12.5003 3.33203Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5477_33928">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DashboardIcon;
